module.exports = __webpack_public_path__ + "static/media/cq_invia_messaggio b.988f5948.svg";